import React from 'react'
import '../../styles.css'
import simg from '../../assets/real_assets/s.jpg'
import mimg from '../../assets/real_assets/m.jpg'
import timg from '../../assets/real_assets/t.jpg'
import pimg from '../../assets/real_assets/p.jpg'
import nimg from '../../assets/real_assets/n.jpg'
import cimg from '../../assets/real_assets/c.jpg'
import kimg from '../../assets/real_assets/k.jpg'
import rimg from '../../assets/real_assets/r.jpg'
import bimg from '../../assets/real_assets/b.jpg'
import jimg from '../../assets/real_assets/j.jpg'
import fimg from '../../assets/real_assets/f.jpg'
import gimg from '../../assets/real_assets/g.jpg'
import himg from '../../assets/real_assets/h.jpg'
import dimg from '../../assets/real_assets/d.jpg'
import wimg from '../../assets/real_assets/w.jpg'
import vimg from '../../assets/real_assets/v.jpg'
import limg from '../../assets/real_assets/l.jpg'
import yimg from '../../assets/real_assets/y.jpg'

const animalImages = {
    's': simg,
    'm': mimg,
    't': timg,
    'p': pimg,
    'n': nimg,
    'c': cimg,
    'k': kimg,
    'r': rimg,
    'b': bimg,
    'j': jimg,
    'f': fimg,
    'g': gimg,
    'h': himg,
    'd': dimg,
    'w': wimg,
    'v': vimg,
    'l': limg,
    'y': yimg
}

const sentences = {
    's': 'The sausage was cooked',
    'm': 'The monkey was thin',
    't': 'The tiger was hungry',
    'p': 'The popcorn was yummy',
    'n': 'The nuts were brown',
    'c': 'The caterpillar was green',
    'k': 'The king was tall',
    'r': 'The rat was dirty',
    'b': 'The ball was round',
    'j': 'The jellybean was small',
    'f': 'The flamingo was pink',
    'g': 'The goat was grey',
    'h': 'The helicopter was flying',
    'd': 'The doll was cute',
    'w': 'The walrus was fat',
    'v': 'The volcano was big',
    'l': 'The lion was golden',
    'y': 'The yak was strong'
}

function LetterIntroduction(props) {
    return (
        <div className='row' style={{marginBottom: 20, width: 600, justifyContent: 'left'}}>
            <div className='introImage'>
                <img src={animalImages[props.letter]} className='photographsInDivs' alt='Letter' />
            </div>
            <div>
                <b className='introBigLetter'>{props.letter}</b>
            </div>
            <div>
                <p className='introSentence'>{sentences[props.letter]}</p>
            </div>
        </div>
    )
}

export default LetterIntroduction
